"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTagWrapper = void 0;
var merch_components_1 = require("@carvana/merch-components");
var react_1 = __importDefault(require("react"));
var OnHoldTag_1 = __importDefault(require("./OnHoldTag"));
var useStatusHooks_1 = require("../../../hooks/useStatusHooks");
var constants_1 = require("../constants");
exports.StatusTagWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'rounded-br-md px-8 py-4 text-xs font-bold text-white'
});
function StatusTags() {
    var showPreOrderTag = (0, useStatusHooks_1.useGetIsPreOrder)();
    var _a = (0, useStatusHooks_1.useGetPurchaseStatus)(), showLockedTag = _a.isLocked, showOnHoldTag = _a.isOnHold;
    return (react_1.default.createElement("div", { className: "absolute left-0 top-0 flex " },
        showOnHoldTag && react_1.default.createElement(OnHoldTag_1.default, null),
        showPreOrderTag && (react_1.default.createElement(exports.StatusTagWrapper, { className: constants_1.tagColorMap.reservable, "data-qa": "text-only-reservable" }, "Pre-Order Now")),
        showLockedTag && (react_1.default.createElement(exports.StatusTagWrapper, { className: constants_1.tagColorMap.locked, "data-qa": "text-only-locked" }, "Purchase in Progress"))));
}
exports.default = StatusTags;
//# sourceMappingURL=StatusTags.js.map